import React, { useMemo } from 'react';
import { StatusLabel } from '@sierralabs/core-ui';
import {
  FormatComponentProps,
  SiteComponent,
  SiteComponentConfigProps,
  SiteComponentPlugin,
  SiteComponentProps,
  SiteTaskStatusLabelConfigurator,
  useQueryValue,
  useSiteContext,
  useSubscribeComponentChanges
} from '@sierralabs/site-ui';

import TaskStatusLabel from '../common/TaskStatusLabel';

export interface QmsTaskStatusLabelProps {
  status?: { queryId?: string; queryField?: string };
  workflowId?: { queryId?: string; queryField?: string };
}

export const QmsTaskStatusLabel: React.FC<
  SiteComponentProps<QmsTaskStatusLabelProps> & FormatComponentProps
> = props => {
  const component = useSubscribeComponentChanges(
    QmsTaskStatusLabelPlugin,
    props
  );
  const { editing, isHover, hoverProps } = useSiteContext();
  const classes = ['qms-task-status-label'];
  if (isHover(component)) {
    classes.push('component-hover');
  }
  const cProps = component.props || {};
  const status = useQueryValue(
    cProps.status?.queryId,
    cProps.status?.queryField,
    props.queryValueProps
  );
  const workflowId = useQueryValue(
    cProps.workflowId?.queryId,
    cProps.workflowId?.queryField,
    props.queryValueProps
  );
  const task = useMemo(() => {
    return status || workflowId ? { status, workflowId } : undefined;
  }, [status, workflowId]);
  const content = task ? <TaskStatusLabel task={task} /> : <StatusLabel />;
  return (
    <SiteComponent plugin={QmsTaskStatusLabelPlugin} {...props}>
      {editing ? (
        <div className={classes.join(' ')} {...hoverProps(component)}>
          {content}
        </div>
      ) : (
        content
      )}
    </SiteComponent>
  );
};

export const QmsTaskStatusLabelConfigurator: React.FC<
  SiteComponentConfigProps<QmsTaskStatusLabelProps>
> = props => {
  // same configurator but different interface for props
  return <SiteTaskStatusLabelConfigurator {...props} />;
};

export const QmsTaskStatusLabelPlugin: SiteComponentPlugin<QmsTaskStatusLabelProps> =
  {
    name: 'QMS Task Status Label',
    type: 'qms-task-status-label',
    component: QmsTaskStatusLabel,
    configurator: QmsTaskStatusLabelConfigurator
  };
